module.exports = __webpack_public_path__ + "img/tradition2.1088d461.png";